import { useCallback } from "react";
import CommonValidatorProps from "./commonProps";
import useValidator from "./useValidator";
import { useTranslation } from "react-i18next";
export interface SelectValidatorProps<T> extends Omit<CommonValidatorProps<T>, "initialValue" | "validationFunction"> {
  required?: boolean;
  initialValue?: string | T;
}

const useSelectValidator = <T,>(props: SelectValidatorProps<T>) => {
  const { t } = useTranslation();
  const { required } = props;

  const validateRequired = useCallback(
    (value?: string | T): [boolean, string] => {
      if (typeof value === "string" || (typeof value === "object" && Array.isArray(value)))
        return [required ? value !== undefined && value.length > 0 : true, t("field:helper.fieldIsRequired")];
      else return [required ? value !== undefined && value !== null : true, t("field:helper.fieldIsRequired")];
    },
    [required]
  );

  const validator = useValidator({ ...props, validators: [validateRequired] });

  return validator;
};

export default useSelectValidator;
